import {createFileRoute} from '@tanstack/react-router';

import {
  layerTemplateKeys,
  layoutTemplateKeys,
} from '@/features/Library/api/queryKeys';
import {getLayerTemplates} from '@/features/Library/api/readLayerTemplates';
import {getLayoutTemplate} from '@/features/Library/api/readLayoutTemplate';
import {LayoutTemplateProfile} from '@/features/Library/components/Location/LayoutTemplateProfile';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute(
  '/_b/_p/_library/locations_/$layoutTemplateId'
)({
  component: LayoutTemplateProfile,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.layoutTemplateId);

    return {
      ...context,
      readLayoutTemplateQuery: {
        queryKey: layoutTemplateKeys.detail(params.layoutTemplateId),
        queryFn: () => getLayoutTemplate(params.layoutTemplateId),
      },
      readLayerTemplatesQuery: {
        queryKey: layerTemplateKeys.list({layoutId: params.layoutTemplateId}),
        queryFn: () => getLayerTemplates({layoutId: params.layoutTemplateId}),
      },
    };
  },

  loader({context}) {
    return Promise.all([
      context.queryClient.ensureQueryData(context.readLayoutTemplateQuery),
      context.queryClient.ensureQueryData(context.readLayerTemplatesQuery),
    ]);
  },
});
